import { LocationStrategy } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import {
  AuthService,
  CostaAppService,
  DateService,
  HomeService,
} from '../../_services';
import { Constants, SessionStoragerService } from '../../_utility';
import {
  Companion,
  Restaurant,
  Slot,
  SlotCategory,
  Slots,
} from '../../_models';

@Component({
  standalone: false,
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CalendarComponent implements OnInit {
  public date: Date[] = [];
  public minDate: Date = new Date();
  public maxDate: Date = new Date();
  public disabledDates: Date[] = [];
  public restaurant!: Restaurant;
  public passengers: Array<Companion> = [];
  public slotsData!: Array<Slots>;
  public slots!: Array<Slot> | null | undefined;
  public selectedDate!: Date | null | undefined;
  public selectedSlots!: Slot | null | undefined;
  public disabledLunch: boolean = false;
  public disabledDinner: boolean = false;
  public loadedSlots: boolean = false;
  public autologin: boolean = true;
  public accordionValue: string[] = [];
  public phone_number: string = '5555';

  constructor(
    private router: Router,
    private service: HomeService,
    private spinner: SpinnerService,
    private sStore: SessionStoragerService,
    private location: LocationStrategy,
    private message: MessageService,
    private dateService: DateService,
    private costaApp: CostaAppService,
    private cdRef: ChangeDetectorRef,
    private auth: AuthService
  ) {
    let restaurant = this.sStore.getElement(Constants.Storager.RESTAURANT);
    let passengers = this.sStore.getElement(Constants.Storager.COMPANIONS);
    this.autologin = this.sStore.getElement(Constants.Storager.AUTOLOGIN);
    let phone_number = this.sStore.getElement(Constants.Storager.PHONE_NUMBER);
    if (!!phone_number) {
      this.phone_number = phone_number;
    }
    if (restaurant && passengers) {
      this.restaurant = restaurant;
      this.passengers = passengers;
    } else {
      this.router.navigate(Constants.Routing.HOME.routerLink);
    }
  }

  ngOnInit(): void {
    this.Slots();
  }

  Back() {
    this.location.back();
  }

  Close() {
    this.costaApp.close();
    if (!this.autologin) {
      this.auth.SignOut();
    }
  }

  Slots() {
    if (this.passengers && this.passengers.length > 0) {
      this.spinner.show();
      let uuid_restaurant = this.restaurant.uuid_restaurant!;
      let companions: string[] = [];
      for (let o of this.passengers) {
        companions.push(o.uuid_passenger!);
      }
      this.service.RestaurantSlot(uuid_restaurant, companions).subscribe({
        next: (res: Array<Slots>) => {
          this.slotsData = res;
          if (res.length > 0) {
            for (let slot of res) {
              let date = this.dateService.parseDateToLocal(slot.date!);
              this.date.push(date);
            }
            this.minDate = this.date[0];
            this.maxDate = this.date.at(-1)!;
            this.disabledDates = this.dateService.calculateDisabledDates(
              this.minDate,
              this.maxDate,
              this.date
            );
            this.selectedDate = this.date[0];
            this.SelectSlots(this.date[0]);
            this.cdRef.detectChanges();
          }
          this.loadedSlots = true;
          this.spinner.hide();
        },
        error: (err) => {
          this.loadedSlots = true;
          this.spinner.hide();
        },
      });
    }
  }

  SelectSlots(event: Date) {
    this.disabledDinner = false;
    this.disabledLunch = false;
    let date = new Date(event);
    let fulldate =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2);
    this.selectedDate = event;
    this.slots = [];

    for (const el in this.slotsData) {
      if (this.slotsData[el].date == fulldate) {
        this.slots = this.slotsData[el].slots;
        this.disabledLunch = true;
        this.disabledDinner = true;
        for (let o of this.slotsData[el].slots!) {
          if (o.category == SlotCategory.lunch) {
            this.disabledLunch = false;
          }
          if (o.category == SlotCategory.dinner) {
            this.disabledDinner = false;
          }
          if (!this.disabledLunch && !this.disabledDinner) {
            break;
          }
        }
      }
    }
    if (!this.disabledLunch) {
      this.accordionValue = ['lunch'];
    } else if (!this.disabledDinner) {
      this.accordionValue = ['dinner'];
    } else {
      this.accordionValue = [];
    }
  }

  SelectSlot(val: Slot) {
    if (val.bookable) {
      this.slots!.forEach((el: any) => {
        el.selected = false;
      });
      val.selected = !val.selected;
      this.selectedSlots = val;
    }
  }

  Proceed() {
    if (this.selectedSlots) {
      let data = { date: this.selectedDate, slot: this.selectedSlots };
      this.sStore.setElement(Constants.Storager.SLOT, data);
      this.router.navigate(Constants.Routing.SUMMARY.routerLink);
    }
  }
}
